<!-- SVG Curve Top -->
<div class="footer-curve">
  <svg viewBox="0 0 1440 120" width="100%" height="80" preserveAspectRatio="none">
    <path d="M0,80 Q360,0 720,80 T1440,80 V120 H0 Z" fill="#66aee06e" />
  </svg>
</div>

<footer class="modern-footer">
  <div class="footer-container">
    <div class="footer-content">



      <!-- Navigation Sections - Right Side -->
      <div class="footer-navigation">

        <!-- Customer Support Column -->
        <div class="footer-column">
          <h3 class="footer-title">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24">
              <g fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" stroke-width="0.3" stroke="currentColor">
                <path
                  d="M9.746 18.286q-.613-.135-1.2-.36a5.6 5.6 0 0 1-1.088-.55a4.31 4.31 0 0 1-1.999-3.507a6.2 6.2 0 0 1 1.25-3.937a6.3 6.3 0 0 1 2.068-1.839a6.8 6.8 0 0 1 2.668-.77a6.235 6.235 0 0 1 5.996 3.558a4.577 4.577 0 0 1-1.76 6.376a.39.39 0 0 0-.14.54a.38.38 0 0 0 .53.14c3.208-1.76 3.578-4.907 2.369-7.536a7.5 7.5 0 0 0-6.995-4.396a7.7 7.7 0 0 0-3.208.939a7.3 7.3 0 0 0-3.687 6.995a5.2 5.2 0 0 0 2.458 4.127q.6.346 1.26.56q.635.22 1.298.34a.36.36 0 0 0 .42-.28a.35.35 0 0 0-.24-.4" />
                <path
                  d="M11.905 16.807a2.68 2.68 0 0 0 1.998-1.709a.38.38 0 0 0-.16-.53a.38.38 0 0 0-.53.16a1.78 1.78 0 0 1-1.838.77a2.4 2.4 0 0 1-.6-.15a2.42 2.42 0 0 1-1.269-.95a.34.34 0 0 0-.5-.18a.35.35 0 0 0-.18.46c.209.75.69 1.396 1.35 1.81c.306.178.646.29.999.329q.365.05.73-.01" />
                <path
                  d="M23.886 12.45a3 3 0 0 0-.29-.76a3.47 3.47 0 0 0-2.238-1.678a12 12 0 0 0-.36-1.739a9.13 9.13 0 0 0-5.066-5.806a10.15 10.15 0 0 0-7.995.35a8.4 8.4 0 0 0-5.046 6.076c0 .24 0 .48-.06.72A3.48 3.48 0 0 0 .413 11.37q-.196.36-.29.76a3 3 0 0 0 0 1.698a2.67 2.67 0 0 0 1.889 1.699q.297.094.61.13q.304.03.609 0a.4.4 0 0 0 .38-.33a.3.3 0 0 0 .26 0a.34.34 0 0 0 .2-.32a17.3 17.3 0 0 1-.44-2.998c-.056-.987.014-1.978.21-2.948a7.47 7.47 0 0 1 4.636-5.046a9 9 0 0 1 6.995-.33a8.05 8.05 0 0 1 4.527 4.917a10.3 10.3 0 0 1-.19 6.995a.39.39 0 0 0 .22.51a.3.3 0 0 0 .19 0a9.7 9.7 0 0 1-1 1.648c-.37.501-.802.951-1.289 1.34a4.2 4.2 0 0 1-2.718 1.079a.39.39 0 0 0-.47-.18a.4.4 0 0 0-.22.52c0 .13 0 .22-.13.31c-.16.12-.35.197-.549.219a1.8 1.8 0 0 1-.84-.04a2 2 0 0 1-.759-.37c-.17-.12-.3-.2-.24-.32a.8.8 0 0 1 .34-.34l.68-.22a4 4 0 0 1 .58-.05h.619a.34.34 0 0 0 .39-.279a.35.35 0 0 0-.28-.41l-1.33-.22a3 3 0 0 0-.509 0a2.5 2.5 0 0 0-.53.1a1.72 1.72 0 0 0-1.219 1.14a1.53 1.53 0 0 0 .74 1.639c.4.264.854.434 1.329.5c.453.045.911-.013 1.339-.17c.41-.155.759-.435 1-.8q.064-.14.1-.29a4.8 4.8 0 0 0 2.997-.58a5.5 5.5 0 0 0 1.999-1.998a7.2 7.2 0 0 0 .909-2.328h.28q.31-.05.61-.14a2.67 2.67 0 0 0 1.808-1.7a2.94 2.94 0 0 0 .03-1.718M2.741 14.808a4 4 0 0 1-.42-.17a1.73 1.73 0 0 1-.93-1.179a2.5 2.5 0 0 1 .001-.999a2.92 2.92 0 0 1 1.349-1.998q-.015.821.06 1.638c.1.984.287 1.958.56 2.908c-.06 0-.1-.07-.17-.07zm18.987.14c-1.51.73-.1-.939-.27-4.117a3 3 0 0 1 1.189 1.919c.066.33.066.67 0 1a1.72 1.72 0 0 1-.96 1.198z" />
                <path
                  d="M8.837 10.521a1.4 1.4 0 0 0-.53.09c-.38.15-.72.382-1 .68a.35.35 0 0 0-.11.48c.14.25 2 0 2.36 0q.239.01.469.08a.41.41 0 0 0 .55-.13a.4.4 0 0 0-.13-.54a2.4 2.4 0 0 0-1.08-.62a1.6 1.6 0 0 0-.53-.04m7.246 1.249a.35.35 0 0 0-.12-.48a2.6 2.6 0 0 0-1-.679a1.4 1.4 0 0 0-.53-.09c-.181-.01-.364.01-.539.06c-.407.11-.779.324-1.08.62a.4.4 0 0 0-.119.54a.4.4 0 0 0 .55.13q.229-.07.47-.08c1.128-.09 2.158.34 2.368-.02" />
              </g>
            </svg>
            Customer Support
          </h3>
          <ul class="footer-links">
            <li>
              <a routerLink="/help-support" target="_blank" class="footer-link">
                <svg class="link-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
                    fill="currentColor" />
                </svg>
                Help and support
              </a>
            </li>
            <li>
              <a routerLink="/services" target="_blank" class="footer-link">
                <svg class="link-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                    fill="currentColor" />
                </svg>
                Product information
              </a>
            </li>
            <li>
              <a class="footer-link">
                <svg class="link-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
                    fill="currentColor" />
                </svg>
                Contact us
              </a>
            </li>
            <li>
              <a routerLink="/accessibility" target="_blank" class="footer-link">
                <svg class="link-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z"
                    fill="currentColor" />
                </svg>
                Accessibility
              </a>
            </li>
          </ul>

          <!-- Copyright Section - Below Accessibility -->
          <div class="footer-copyright">
            <div class="logo-section">
              <img src="../../../../../assets/images/heart-t.png" alt="HPS Life Logo" class="footer-logo">
            </div>
            <div class="copyright-text">
              <p>Copyright © 2025 HPS Life</p>
            </div>
          </div>
        </div>

        <!-- Legal Column -->
        <div class="footer-column">
          <h3 class="footer-title">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 32 32">
              <path fill="currentColor"
                d="M23 16c-3.9 0-7 3.1-7 7s3.1 7 7 7s7-3.1 7-7s-3.1-7-7-7m0 12V18c2.8 0 5 2.2 5 5s-2.2 5-5 5M8 16h6v2H8zm0-6h12v2H8z"
                stroke-width="0.3" stroke="currentColor" />
              <path fill="currentColor"
                d="M26 4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v13c0 4.1 2.2 7.8 5.8 9.7l5.2 2.8v-2.3l-4.2-2.3C5.8 23.4 4 20.3 4 17V4h20v9h2z"
                stroke-width="0.3" stroke="currentColor" />
            </svg>
            Legal
          </h3>
          <ul class="footer-links">
            <li>
              <a routerLink="/regulatory" target="_blank" class="footer-link">
                <svg class="link-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"
                    fill="currentColor" />
                </svg>
                Regulatory Information
              </a>
            </li>
            <li>
              <a routerLink="/terms" target="_blank" class="footer-link">
                <svg class="link-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"
                    fill="currentColor" />
                </svg>
                Terms of use
              </a>
            </li>
            <li>
              <a routerLink="/terms" target="_blank" class="footer-link">
                <svg class="link-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"
                    fill="currentColor" />
                </svg>
                Privacy policy
              </a>
            </li>
            <li>
              <a routerLink="/terms" target="_blank" class="footer-link">
                <svg class="link-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
                    fill="currentColor" />
                </svg>
                Cookie policy
              </a>
            </li>
            <li>
              <a routerLink="/terms" target="_blank" class="footer-link">
                <svg class="link-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
                    fill="currentColor" />
                </svg>
                Modern slavery statement
              </a>
            </li>
          </ul>
        </div>

        <!-- Contact Us Column -->
        <div class="footer-column">
          <h3 class="footer-title">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24">
              <path fill="currentColor"
                d="M19.077 11.462q-.173-2.83-2.153-4.809T12.116 4.5v-1q1.625.077 3.04.722q1.417.645 2.485 1.713t1.714 2.485q.645 1.416.722 3.041zm-4 0q-.173-1.154-.99-1.981T12.116 8.5v-1q1.575.154 2.681 1.27t1.28 2.692zM19.2 20q-2.702 0-5.418-1.244t-5.005-3.533q-2.27-2.289-3.523-5.021Q4 7.469 4 4.8V4h4.439l.848 4.083l-2.696 2.51q.684 1.186 1.417 2.167t1.527 1.769q.802.84 1.808 1.57t2.296 1.44l2.611-2.708l3.75.756V20zM6.121 9.654l2.092-1.92L7.635 5h-2.63q.03 1.144.309 2.305q.278 1.16.807 2.349m8.45 8.335q.923.463 2.09.723t2.339.277v-2.605l-2.388-.475zm0 0"
                stroke-width="0.3" stroke="currentColor" />
            </svg>
            Get in touch
          </h3>
          <p class="contact-description">Questions or feedback?</p>
          <p class="contact-description">We'd love to hear from you</p>

          <!-- Contact Sections Side by Side -->
          <div class="contact-sections-container">
            <!-- For Customers -->
            <div class="contact-section">
              <h4 class="contact-subtitle">For customers:</h4>
              <div class="contact-item">
                <a (click)="openEmail('info@hpslife.co.uk')" class="contact-link">
                  <svg class="contact-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
                      fill="currentColor" />
                  </svg>
                  <span class="contact-text">info&#64;hpslife.co.uk</span>
                </a>
              </div>
              <div class="contact-item">
                <a (click)="openPhone('0208 123 4567')" class="contact-link">
                  <svg class="contact-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
                      fill="currentColor" />
                  </svg>
                  <span class="contact-text">0208 123 4567</span>
                </a>
              </div>
            </div>

            <!-- For Advisers -->
            <div class="contact-section">
              <h4 class="contact-subtitle">For advisers:</h4>
              <div class="contact-item">
                <a (click)="openEmail('adviser@hpslife.co.uk')" class="contact-link">
                  <svg class="contact-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
                      fill="currentColor" />
                  </svg>
                  <span class="contact-text">adviser&#64;hpslife.co.uk</span>
                </a>
              </div>
              <div class="contact-item">
                <a (click)="openPhone('0208 123 4568')" class="contact-link">
                  <svg class="contact-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
                      fill="currentColor" />
                  </svg>
                  <span class="contact-text">0208 123 4568</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>